{
  "{{ commaSeparatedUsers }} and {{ moreCount }} more": "{{ commaSeparatedUsers }} と {{ moreCount }} 他人",
  "{{ commaSeparatedUsers }}, and {{ lastUser }}": "{{ commaSeparatedUsers }} と {{ lastUser }}",
  "{{ count }} files_one": "{{ count }} ファイル",
  "{{ count }} files_other": "{{ count }} ファイル",
  "{{ count }} members_other": "{{ count }}人のメンバー",
  "{{ count }} members added_other": "{{ count }}人のメンバーを追加しました",
  "{{ count }} people are typing_one": "{{ count }}人が入力中です",
  "{{ count }} people are typing_many": "{{ count }}人が入力中です",
  "{{ count }} people are typing_other": "{{ count }}人が入力中です",
  "{{ count }} photos_one": "{{ count }} 写真",
  "{{ count }} photos_other": "{{ count }} 写真",
  "{{ count }} reactions_other": "{{ count }}件のリアクション",
  "{{ count }} videos_one": "{{ count }} 動画",
  "{{ count }} videos_other": "{{ count }} 動画",
  "{{ firstUser }} and {{ secondUser }}": "{{ firstUser }} と {{ secondUser }}",
  "{{ imageCount }} more": "{{ imageCount }} イメージ",
  "{{ member }} will be able to message you again.": "{{ member }}は再びメッセージを送信できるようになります。",
  "{{ member }} won't be able to message you anymore.": "{{ member }}はメッセージを送信できなくなります。",
  "{{ memberCount }} members": "{{ memberCount }} メンバー",
  "{{ typing }} are typing": "{{ typing }}が入力中です",
  "{{ typing }} is typing": "{{ typing }}が入力中です",
  "{{ user }} has been muted": "{{ user }} 無音されています",
  "{{ user }} has been unmuted": "{{ user }} 無音されていません",
  "{{ user }} is typing...": "{{ user }} が入力中...",
  "{{ users }} and {{ user }} are typing...": "{{ users }} と {{ user }} が入力中...",
  "{{ users }} and more are typing...": "{{ users }} とその他が入力中...",
  "{{ watcherCount }} online": "{{ watcherCount }} オンライン",
  "{{count}} new messages_one": "{{count}}件の新しいメッセージ",
  "{{count}} new messages_other": "{{count}}件の新しいメッセージ",
  "{{count}} unread_one": "{{count}} 未読",
  "{{count}} unread_other": "{{count}} 未読",
  "{{count}} votes_one": "{{count}} 票",
  "{{count}} votes_other": "{{count}} 票",
  "+{{ imageCount }}": "+{{ imageCount }}",
  "+{{count}} more options_one": "あと{{count}}件のオプション",
  "+{{count}} more options_other": "あと{{count}}件のオプション",
  "🏙 Attachment...": "🏙 アタッチメント...",
  "📊 {{createdBy}} created: {{ pollName}}": "📊 {{createdBy}} が作成: {{ pollName}}",
  "📊 {{votedBy}} voted: {{pollOptionText}}": "📊 {{votedBy}} が投票: {{pollOptionText}}",
  "📍Shared location": "📍共有された位置情報",
  "Actions": "Actions",
  "Add": "追加",
  "Add {{ count }} members_other": "{{ count }}人のメンバーを追加",
  "Add a comment": "コメントを追加",
  "Add a comment to your poll answer": "投票回答にコメントを追加",
  "Add an option": "オプションを追加",
  "Add channel members": "チャンネルメンバーを追加",
  "Add members": "メンバーを追加",
  "Add reaction": "リアクションを追加",
  "Admin": "管理者",
  "All results loaded": "すべての結果が読み込まれました",
  "Allow access to camera": "カメラへのアクセスを許可する",
  "Allow access to microphone": "マイクロフォンへのアクセスを許可する",
  "Allow comments": "コメントを許可",
  "Allow option suggestion": "オプションの提案を許可",
  "Allow others to add comments": "他の人にコメントを追加することを許可する",
  "Already a member": "すでにメンバーです",
  "Also send as a direct message": "ダイレクトメッセージとしても送信",
  "Also send in channel": "チャンネルにも送信",
  "Also sent in channel": "チャンネルにも送信済み",
  "An error has occurred during recording": "録音中にエラーが発生しました",
  "An error has occurred during the recording processing": "録音処理中にエラーが発生しました",
  "Anonymous": "匿名",
  "Anonymous poll": "匿名投票",
  "Archive": "アーカイブ",
  "Are you sure you want to delete this message?": "このメッセージを削除してもよろしいですか？",
  "Are you sure you want to leave this channel?": "Are you sure you want to leave this channel?",
  "aria/Attachment": "添付ファイル",
  "aria/Attachment Actions": "添付ファイルの操作",
  "aria/Audio position {{ elapsed }} of {{ duration }}": "音声位置 {{ elapsed }} / {{ duration }}",
  "aria/Audio position {{ progress }} percent": "音声位置 {{ progress }} パーセント",
  "aria/Block User": "ユーザーをブロック",
  "aria/Bookmark Message": "メッセージをブックマーク",
  "aria/Cancel recording": "録音をキャンセル",
  "aria/Cancel Reply": "返信をキャンセル",
  "aria/Cancel upload": "アップロードをキャンセル",
  "aria/Channel Actions": "チャンネル操作",
  "aria/Channel details": "チャンネル詳細",
  "aria/Channel list": "チャンネル一覧",
  "aria/Channel search results": "チャンネル検索結果",
  "aria/Chat view tabs": "チャットビューのタブ",
  "aria/Clear search": "検索をクリア",
  "aria/Close callout dialog": "吹き出しダイアログを閉じる",
  "aria/Close thread": "スレッドを閉じる",
  "aria/Collapse sidebar": "サイドバーを折りたたむ",
  "aria/Command Suggestions": "コマンド候補",
  "aria/Complete recording": "録音を完了",
  "aria/Copy Message Text": "メッセージテキストをコピー",
  "aria/Decrease value": "値を減らす",
  "aria/Delete Message": "メッセージを削除",
  "aria/Dismiss notification": "通知を閉じる",
  "aria/Download attachment": "添付ファイルをダウンロード",
  "aria/Edit Message": "メッセージを編集",
  "aria/Emoji picker": "絵文字ピッカー",
  "aria/Emoji Suggestions": "絵文字候補",
  "aria/Exit search": "検索を終了",
  "aria/Expand sidebar": "サイドバーを展開",
  "aria/File input": "ファイル入力",
  "aria/File upload": "ファイルアップロード",
  "aria/Flag Message": "メッセージをフラグ",
  "aria/Image failed to load": "画像の読み込みに失敗しました",
  "aria/Image input": "画像入力",
  "aria/Increase value": "値を増やす",
  "aria/Jump to latest message": "最新のメッセージに移動",
  "aria/Jump to quoted message": "引用されたメッセージに移動",
  "aria/Load More Channels": "さらにチャンネルを読み込む",
  "aria/Mark Message Unread": "未読としてマーク",
  "aria/Mark messages as read": "メッセージを既読にする",
  "aria/Mention Suggestions": "メンション候補",
  "aria/Menu": "メニュー",
  "aria/Message Actions": "メッセージ操作",
  "aria/Message from {{ user }},": "{{ user }}さんからのメッセージ,",
  "aria/Message Options": "メッセージオプション",
  "aria/Message,": "メッセージ,",
  "aria/Mute User": "ユーザーをミュート",
  "aria/Next page": "次のページ",
  "aria/Notifications": "通知",
  "aria/Open Attachment Selector": "添付ファイル選択を開く",
  "aria/Open Channel Actions Menu": "チャンネルアクションメニューを開く",
  "aria/Open channel details": "チャンネル詳細を開く",
  "aria/Open image shared by {{ name }}": "{{ name }}が共有した画像を開く",
  "aria/Open Menu": "メニューを開く",
  "aria/Open Message Actions Menu": "メッセージアクションメニューを開く",
  "aria/Open Reaction Selector": "リアクションセレクターを開く",
  "aria/Open Thread": "スレッドを開く",
  "aria/Open video shared by {{ name }}": "{{ name }}が共有した動画を開く",
  "aria/Pause": "一時停止",
  "aria/Pause recording": "録音を一時停止",
  "aria/Percent complete": "{{percent}}パーセント完了",
  "aria/Pin Message": "メッセージをピン",
  "aria/Play": "再生",
  "aria/Previous page": "前のページ",
  "aria/Quote Message": "メッセージを引用",
  "aria/Reaction list": "リアクション一覧",
  "aria/Remind Me Message": "リマインダー",
  "aria/Remind Me Options": "リマインダーオプション",
  "aria/Remove attachment": "添付ファイルを削除",
  "aria/Remove location attachment": "位置情報の添付ファイルを削除",
  "aria/Remove option": "オプションを削除",
  "aria/Remove Reminder": "リマインダーを削除",
  "aria/Remove Save For Later": "「後で見る」を削除",
  "aria/Resend Message": "メッセージを再送信",
  "aria/Resume recording": "録音を再開",
  "aria/Retry upload": "アップロードを再試行",
  "aria/Review bounced message": "バウンスされたメッセージを確認",
  "aria/Search results": "検索結果",
  "aria/Search results header filter button for: {{ source }}": "{{ source }} の検索結果ヘッダーのフィルターボタン",
  "aria/Seek audio position": "音声位置をシーク",
  "aria/Select Channel: {{ channelName }}": "チャンネルを選択: {{ channelName }}",
  "aria/Select Reaction: {{ reactionName }}": "リアクションを選択: {{ reactionName }}",
  "aria/Select User Channel: {{ name }}": "ユーザーチャンネルを選択: {{ name }}",
  "aria/Send": "送信",
  "aria/Show preview": "プレビューを表示",
  "aria/Start recording audio": "音声録音を開始",
  "aria/Stop AI Generation": "AI生成を停止",
  "aria/Suggestions": "候補",
  "aria/Thread list": "スレッド一覧",
  "aria/Unblock User": "ユーザーのブロックを解除",
  "aria/Unmute User": "無音を解除する",
  "aria/Unpin Message": "ピンを解除",
  "Ask a question": "質問する",
  "Attach": "添付",
  "Attach files": "ファイルを添付する",
  "Attachment": "添付ファイル",
  "Attachment upload blocked due to {{reason}}": "{{reason}}のため添付ファイルのアップロードがブロックされました",
  "Attachment upload failed due to {{reason}}": "{{reason}}のため添付ファイルのアップロードに失敗しました",
  "Back": "戻る",
  "ban-command-args": "[@ユーザ名] [テキスト]",
  "ban-command-description": "ユーザーを禁止する",
  "Block user": "ユーザーをブロック",
  "Block User": "ユーザーをブロック",
  "Browse channel members": "チャンネルメンバーを表示",
  "Browse pinned messages": "ピン留めメッセージを表示",
  "Cancel": "キャンセル",
  "Cannot seek in the recording": "録音中にシークできません",
  "Changes saved": "変更を保存しました",
  "Channel archived": "チャンネルをアーカイブしました",
  "Channel members": "チャンネルメンバー",
  "Channel Missing": "チャネルがありません",
  "Channel muted": "チャンネルをミュートしました",
  "Channel pinned": "チャンネルをピン留めしました",
  "Channel unarchived": "チャンネルのアーカイブを解除しました",
  "Channel unmuted": "チャンネルのミュートを解除しました",
  "Channel unpinned": "チャンネルのピン留めを解除しました",
  "Channels": "チャンネル",
  "Chat deleted": "Chat deleted",
  "Chats": "チャット",
  "Choose between 2 to 10 options": "2〜10の選択肢から選ぶ",
  "Close": "閉める",
  "Close dialog": "ダイアログを閉じる",
  "Close emoji picker": "絵文字ピッカーを閉める",
  "Close prompt: {{ title }}": "プロンプトを閉じる: {{ title }}",
  "Command not available while editing": "編集中はコマンドを使用できません",
  "Command not available while replying": "返信中はコマンドを使用できません",
  "Commands": "コマンド",
  "Commands matching": "一致するコマンド",
  "Connection failure, reconnecting now...": "接続が失敗しました。再接続中...",
  "Contact info": "連絡先情報",
  "Contact name": "連絡先名",
  "Copy Message": "メッセージをコピー",
  "Create": "作成",
  "Create a question, add options, and configure poll settings": "質問を作成し、選択肢を追加して投票設定を構成",
  "Create poll": "投票を作成",
  "Current location": "現在の位置",
  "Delete": "消去",
  "Delete chat": "チャットを削除",
  "Delete for me": "自分用に削除",
  "Delete message": "メッセージを削除",
  "Delivered": "配信しました",
  "Direct message": "ダイレクトメッセージ",
  "Do you want to end this poll now? Nobody will be able to vote in this poll anymore.": "このアンケートを今終了しますか？終了すると、誰も投票できなくなります。",
  "Download All": "すべてダウンロード",
  "Download Attachment": "添付ファイルをダウンロード",
  "Download attachment {{ name }}": "添付ファイル {{ name }} をダウンロード",
  "Drag your files here": "ここにファイルをドラッグ",
  "Drag your files here to add to your post": "投稿に追加するためにここにファイルをドラッグ",
  "Due {{ timeLeft }}": "{{ timeLeft }}に期限切れ",
  "Due since {{ dueSince }}": "{{ dueSince }}から期限切れ",
  "duration/Message reminder": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Remind Me": "{{ milliseconds | durationFormatter(withSuffix: true) }}",
  "duration/Share Location": "{{ milliseconds | durationFormatter }}",
  "Edit": "編集",
  "Edit chat data": "チャットデータを編集",
  "Edit contact": "連絡先を編集",
  "Edit group": "グループを編集",
  "Edit Message": "メッセージを編集",
  "Edit message request failed": "メッセージの編集要求が失敗しました",
  "Edited": "編集済み",
  "Emoji matching": "絵文字マッチング",
  "Empty message...": "空のメッセージ...",
  "End": "終了",
  "End poll": "アンケートを終了",
  "End this poll?": "このアンケートを終了しますか？",
  "End vote": "投票を終了",
  "Enforce unique vote is enabled": "一意の投票が有効になっています",
  "Error": "エラー",
  "Error adding flag": "フラグを追加のエラーが発生しました",
  "Error adding members": "Error adding members",
  "Error blocking user": "ユーザーのブロック中にエラーが発生しました",
  "Error connecting to chat, refresh the page to try again.": "チャットへの接続ができませんでした。ページを更新してください。",
  "Error deleting chat": "Error deleting chat",
  "Error deleting message": "メッセージを削除するエラーが発生しました",
  "Error fetching reactions": "反応の読み込みエラー",
  "Error marking message unread. Cannot mark unread messages older than the newest 100 channel messages.": "メッセージを未読にする際にエラーが発生しました。最新の100件のチャンネルメッセージより古い未読メッセージはマークできません。",
  "Error muting a user ...": "ユーザーを無音するエラーが発生しました...",
  "Error muting channel": "チャンネルのミュート中にエラーが発生しました",
  "Error muting user": "ユーザーのミュート中にエラーが発生しました",
  "Error opening direct message": "ダイレクトメッセージを開く際にエラーが発生しました",
  "Error pinning message": "メッセージをピンのエラーが発生しました",
  "Error removing members": "メンバーの削除中にエラーが発生しました",
  "Error removing message pin": "メッセージのピンを削除のエラーが発生しました",
  "Error removing user": "ユーザーの削除中にエラーが発生しました",
  "Error reproducing the recording": "録音の再生中にエラーが発生しました",
  "Error starting recording": "録音の開始時にエラーが発生しました",
  "Error unblocking user": "ユーザーのブロック解除中にエラーが発生しました",
  "Error unmuting a user ...": "ユーザーの無音解除のエラーが発生しました...",
  "Error unmuting channel": "チャンネルのミュート解除中にエラーが発生しました",
  "Error unmuting user": "ユーザーのミュート解除中にエラーが発生しました",
  "Error uploading attachment": "添付ファイルのアップロード中にエラーが発生しました",
  "Error uploading file": "ファイルをアップロードのエラーが発生しました",
  "Error uploading image": "画像をアップロードのエラーが発生しました",
  "Error: {{ errorMessage }}": "エラー: {{ errorMessage }}",
  "Exit command {{ command }}": "コマンドを終了 {{ command }}",
  "Failed to block user": "ユーザーのブロックに失敗しました",
  "Failed to create the poll": "投票の作成に失敗しました",
  "Failed to create the poll due to {{reason}}": "{{reason}} のため投票の作成に失敗しました",
  "Failed to delete the message": "メッセージの削除に失敗しました",
  "Failed to end the poll": "アンケートの終了に失敗しました",
  "Failed to end the poll due to {{reason}}": "{{reason}}のためアンケートの終了に失敗しました",
  "Failed to jump to the first unread message": "最初の未読メッセージにジャンプできませんでした",
  "Failed to leave channel": "チャンネルの退出に失敗しました",
  "Failed to load channels": "チャンネルの読み込みに失敗しました",
  "Failed to load more channels": "さらにチャンネルを読み込めませんでした",
  "Failed to mark channel as read": "チャンネルを既読にすることができませんでした",
  "Failed to play the recording": "録音の再生に失敗しました",
  "Failed to retrieve location": "位置情報の取得に失敗しました",
  "Failed to save changes": "変更を保存できませんでした",
  "Failed to share location": "位置情報の共有に失敗しました",
  "Failed to update channel archive status": "チャンネルのアーカイブ状態の更新に失敗しました",
  "Failed to update channel mute status": "チャンネルのミュート状態の更新に失敗しました",
  "Failed to update channel pinned status": "チャンネルのピン状態の更新に失敗しました",
  "File": "ファイル",
  "File is required for upload attachment": "添付ファイルのアップロードにはファイルが必要です",
  "File is too large: {{ size }}, maximum upload size is {{ limit }}": "ファイルが大きすぎます：{{ size }}、最大アップロードサイズは{{ limit }}です",
  "File too large": "ファイルが大きすぎます",
  "fileCount_other": "{{ count }}件のファイル",
  "Files": "ファイル",
  "Flag": "フラグ",
  "Generating...": "生成中...",
  "giphy-command-args": "[テキスト]",
  "giphy-command-description": "チャンネルにランダムなGIFを投稿する",
  "Go back": "戻る",
  "Group info": "グループ情報",
  "Group name": "グループ名",
  "Hide who voted": "誰が投票したかを非表示にする",
  "Image": "画像",
  "imageCount_other": "{{ count }}件の画像",
  "Instant commands": "インスタントコマンド",
  "language/af": "アフリカース語",
  "language/am": "アムハラ語",
  "language/ar": "アラビア語",
  "language/az": "アゼルバイジャン語",
  "language/bg": "ブルガリア語",
  "language/bn": "ベンガル語",
  "language/bs": "ボスニア語",
  "language/cs": "チェコ語",
  "language/da": "デンマーク語",
  "language/de": "ドイツ語",
  "language/el": "ギリシャ語",
  "language/en": "英語",
  "language/es": "スペイン語",
  "language/es-MX": "スペイン語（メキシコ）",
  "language/et": "エストニア語",
  "language/fa": "ペルシア語",
  "language/fa-AF": "ダリー語",
  "language/fi": "フィンランド語",
  "language/fr": "フランス語",
  "language/fr-CA": "フランス語（カナダ）",
  "language/ha": "ハウサ語",
  "language/he": "ヘブライ語",
  "language/hi": "ヒンディー語",
  "language/hr": "クロアチア語",
  "language/ht": "ハイチ・クレオール語",
  "language/hu": "ハンガリー語",
  "language/id": "インドネシア語",
  "language/it": "イタリア語",
  "language/ja": "日本語",
  "language/ka": "グルジア語",
  "language/ko": "韓国語",
  "language/lt": "リトアニア語",
  "language/lv": "ラトビア語",
  "language/ms": "マレー語",
  "language/nl": "オランダ語",
  "language/no": "ノルウェー語",
  "language/pl": "ポーランド語",
  "language/ps": "パシュトー語",
  "language/pt": "ポルトガル語",
  "language/ro": "ルーマニア語",
  "language/ru": "ロシア語",
  "language/sk": "スロバキア語",
  "language/sl": "スロベニア語",
  "language/so": "ソマリ語",
  "language/sq": "アルバニア語",
  "language/sr": "セルビア語",
  "language/sv": "スウェーデン語",
  "language/sw": "スワヒリ語",
  "language/ta": "タミル語",
  "language/th": "タイ語",
  "language/tl": "タガログ語",
  "language/tr": "トルコ語",
  "language/uk": "ウクライナ語",
  "language/ur": "ウルドゥー語",
  "language/vi": "ベトナム語",
  "language/zh": "中国語（簡体字）",
  "language/zh-TW": "中国語（繁体字）",
  "Last seen {{ timestamp }}": "最終表示 {{ timestamp }}",
  "Leave Channel": "チャンネルを退出",
  "Leave chat": "チャンネルを退出",
  "Left channel": "チャンネルを退出しました",
  "Let others add options": "他の人が選択肢を追加できるようにする",
  "Limit votes per person": "1人あたりの投票数を制限する",
  "Link": "リンク",
  "linkCount_other": "{{ count }}件のリンク",
  "live": "ライブ",
  "Live for {{duration}}": "{{duration}}間ライブ",
  "Live location": "ライブ位置情報",
  "Live until {{ timestamp }}": "{{ timestamp }}までライブ",
  "Load more": "もっと読み込む",
  "Local upload attachment missing local id": "ローカルアップロード添付にローカルIDがありません",
  "Location": "位置情報",
  "Location sharing ended": "位置情報の共有が終了しました",
  "Location: {{ coordinates }}": "位置: {{ coordinates }}",
  "Manage channel": "チャンネルを管理",
  "Manage members": "メンバーを管理",
  "Mark as unread": "未読としてマーク",
  "Maximum number of votes (from 2 to 10)": "最大投票数（2から10まで）",
  "Maximum votes per person": "1人あたりの最大投票数",
  "Member detail": "メンバー詳細",
  "mention/Channel": "チャンネル",
  "mention/Channel Description": "このチャンネルの全員に通知",
  "mention/Here": "ここ",
  "mention/Here Description": "このチャンネルのオンライン中の全メンバーに通知",
  "Menu": "メニュー",
  "Message deleted": "メッセージが削除されました",
  "Message failed to send": "メッセージの送信に失敗しました",
  "Message has been successfully flagged": "メッセージに正常にフラグが付けられました",
  "Message marked as unread": "メッセージを未読にしました",
  "Message pinned": "メッセージにピンが付けられました",
  "Message unpinned": "メッセージのピン留めを解除しました",
  "Message was blocked by moderation policies": "メッセージはモデレーションポリシーによってブロックされました",
  "Messages have been marked unread.": "メッセージは未読としてマークされました。",
  "Missing permissions to upload the attachment": "添付ファイルをアップロードするための許可がありません",
  "Moderator": "モデレーター",
  "Multiple votes": "複数投票",
  "Mute": "無音",
  "Mute chat": "チャットをミュート",
  "Mute user": "ユーザーをミュート",
  "mute-command-args": "[@ユーザ名]",
  "mute-command-description": "ユーザーをミュートする",
  "network error": "ネットワークエラー",
  "New": "新しい",
  "New message from {{user}}": "{{user}}からの新しいメッセージ",
  "New Messages!": "新しいメッセージ!",
  "Next": "次へ",
  "Next image": "次の画像",
  "No chats here yet…": "ここにはまだチャットはありません…",
  "No conversations yet": "まだ会話はありません",
  "No files": "ファイルはありません",
  "No items exist": "項目がありません",
  "No member found": "メンバーが見つかりません",
  "No messages found": "メッセージが見つかりません",
  "No photos or videos": "写真や動画はありません",
  "No pinned messages": "ピン留めメッセージはありません",
  "No results found": "結果が見つかりません",
  "No user found": "ユーザーが見つかりません",
  "Nobody will be able to vote in this poll anymore.": "この投票では、誰も投票できなくなります。",
  "Nothing yet...": "まだ何もありません...",
  "Notify all {{ role }} members": "{{ role }} メンバー全員に通知",
  "Offline": "オフライン",
  "Ok": "OK",
  "Online": "オンライン",
  "Only numbers are allowed": "数字のみ許可されています",
  "Only visible to you": "あなただけに表示",
  "Open emoji picker": "絵文字ピッカーを開く",
  "Open gallery at image {{ index }}": "画像 {{ index }} でギャラリーを開く",
  "Open image in gallery": "画像をギャラリーで開く",
  "Open location in a map": "地図で位置情報を開く",
  "Open members actions": "Open members actions",
  "Open menu": "メニューを開く",
  "Option already exists": "オプションは既に存在します",
  "Option is empty": "オプションが空です",
  "Options": "オプション",
  "Original": "原文",
  "Owner": "オーナー",
  "People matching": "一致する人",
  "Photo": "写真",
  "Photos & videos": "写真と動画",
  "Pin": "ピン",
  "Pin a message to see it here": "ここに表示するにはメッセージをピン留めしてください",
  "Pinned by {{ name }}": "{{ name }}がピンしました",
  "Pinned by You": "あなたがピン留めしました",
  "Pinned message": "ピン留めメッセージ",
  "Pinned messages": "ピン留めメッセージ",
  "placeholder/PollComment": "コメント",
  "placeholder/PollOptionSuggestion": "新しい選択肢を入力",
  "Play video": "動画を再生",
  "Playback speed {{ rate }}x": "再生速度 {{ rate }}x",
  "Poll": "投票",
  "Poll comments": "投票コメント",
  "Poll ended": "アンケート終了",
  "Poll options": "投票オプション",
  "Poll results": "投票結果",
  "Previous": "前へ",
  "Previous image": "前の画像",
  "Question": "質問",
  "Question {{ optionOrderNumber}}": "質問 {{ optionOrderNumber}}",
  "Question is required": "質問は必須です",
  "Quote Reply": "引用返信",
  "Reached the vote limit. Remove an existing vote first.": "投票制限に達しました。既存の投票を先に削除してください。",
  "Recording format is not supported and cannot be reproduced": "録音形式はサポートされておらず、再生できません",
  "Remind me": "リマインド",
  "Remind Me": "リマインダー",
  "Reminder set": "リマインダーを設定しました",
  "Remove": "削除",
  "Remove {{ count }} members_other": "{{ count }}人のメンバーを削除",
  "Remove {{ member }} from this channel?": "{{ member }}をこのチャンネルから削除しますか？",
  "Remove channel members": "チャンネルメンバーを削除",
  "Remove reminder": "リマインダーを削除",
  "Remove save for later": "「後で見る」を削除",
  "Remove user": "ユーザーを削除",
  "Removed {{ count }} members_other": "{{ count }}人のメンバーを削除しました",
  "Replied to a thread": "スレッドに返信しました",
  "Reply": "返事",
  "Reply to {{ authorName }}": "{{ authorName }} に返信",
  "Reply to a message to start a thread": "メッセージに返信してスレッドを開始してください",
  "Reply to Message": "メッセージに返信",
  "replyCount_one": "1件の返信",
  "replyCount_other": "{{ count }} 返信",
  "Resend": "再送信",
  "Retry upload": "アップロードを再試行",
  "Review all options available in this poll": "この投票で利用可能なすべての選択肢を確認",
  "Review comments submitted with poll answers": "投票回答とともに送信されたコメントを確認",
  "Review poll results and open an option to see detailed votes": "投票結果を確認し、選択肢を開いて詳細な投票を表示",
  "Review this message and choose whether to delete it, edit it, or send it anyway": "このメッセージを確認し、削除・編集・そのまま送信するかを選択",
  "Review who voted for this option": "この選択肢に投票した人を確認",
  "Save": "保存",
  "Save for later": "後で保存",
  "Saved for later": "後で保存済み",
  "Search": "探す",
  "Search GIFs": "GIFを検索",
  "search-results-header-filter-source-button-label--channels": "チャンネル",
  "search-results-header-filter-source-button-label--messages": "メッセージ",
  "search-results-header-filter-source-button-label--users": "ユーザー",
  "Searching for {{ searchSourceType }}...": "{{ searchSourceType }}を検索中...",
  "Searching...": "検索中...",
  "searchResultsCount_one": "1件の結果",
  "searchResultsCount_other": "{{ count }}件の結果",
  "Select a thread to continue the conversation": "会話を続けるにはスレッドを選択してください",
  "Select more than one option": "複数の選択肢を選ぶ",
  "Select one": "1つ選択",
  "Select one or more": "1つ以上選択",
  "Select up to {{count}}_one": "最大{{count}}まで選択",
  "Select up to {{count}}_other": "最大{{count}}まで選択",
  "Select your current location and optionally enable live location sharing": "現在地を選択し、必要に応じてライブ位置情報共有を有効化",
  "Send": "送信",
  "Send a message": "メッセージを送る",
  "Send a message to start the conversation": "メッセージを送って会話を始めましょう",
  "Send Anyway": "とにかく送信する",
  "Send direct message": "ダイレクトメッセージを送信",
  "Send message request failed": "メッセージ送信リクエストが失敗しました",
  "Send poll": "アンケートを送信",
  "Sending...": "送信中...",
  "Sent": "送信済み",
  "Share": "共有",
  "Share a file to see it here": "ファイルを共有するとここに表示されます",
  "Share a photo or video to see it here": "写真や動画を共有するとここに表示されます",
  "Share live location for": "ライブ位置情報を共有",
  "Share Location": "位置情報を共有",
  "Shared live location": "共有されたライブ位置情報",
  "Shared location": "共有された位置情報",
  "Shuffle": "シャッフル",
  "size limit": "サイズ制限",
  "Slow Mode ON": "スローモードオン",
  "Slow mode, wait {{ seconds }}s...": "スローモード、{{ seconds }}秒お待ちください...",
  "Some of the files will not be accepted": "一部のファイルは受け付けられません",
  "Start typing to search": "検索するには入力を開始してください",
  "Stop sharing": "共有を停止",
  "Submit": "送信",
  "Suggest a new option to add to this poll": "この投票に追加する新しい選択肢を提案",
  "Suggest an option": "オプションを提案",
  "Tap to remove": "タップして削除",
  "Tap to remove: {{ reactionName }}": "タップして削除: {{ reactionName }}",
  "Thinking...": "考え中...",
  "this content could not be displayed": "このコンテンツは表示できませんでした",
  "This field cannot be empty or contain only spaces": "このフィールドは空にすることはできません。また、空白文字のみを含むこともできません",
  "This message did not meet our content guidelines": "このメッセージはコンテンツガイドラインに適合していません",
  "This permanently deletes your message history with {{ user }}. This can't be undone.": "This permanently deletes your message history with {{ user }}. This can't be undone.",
  "This user will be able to message you again.": "このユーザーは再びあなたにメッセージを送信できるようになります。",
  "This user won't be able to message you anymore. You can unblock them anytime.": "This user won't be able to message you anymore. You can unblock them anytime.",
  "Thread": "スレッド",
  "Thread has not been found": "スレッドが見つかりませんでした",
  "Thread reply": "スレッドの返信",
  "Thread Reply": "スレッドの返信",
  "ThreadListUnseenThreadsBanner/loading": "読み込み中...",
  "ThreadListUnseenThreadsBanner/unreadThreads_other": "{{ count }}件の未読スレッド",
  "Threads": "スレッド",
  "timestamp/ChannelDetailPinnedMessageTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[Yesterday]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/ChannelMembersLastActive": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/ChannelPreviewTimestamp": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"LT\", \"lastDay\": \"[昨日]\", \"lastWeek\": \"dddd\", \"sameElse\": \"L\" }) }}",
  "timestamp/DateSeparator": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[今日]\", \"nextDay\": \"[明日]\", \"lastDay\": \"[昨日]\", \"nextWeek\": \"dddd\", \"lastWeek\": \"[先週の] dddd\", \"sameElse\": \"ddd, D MMM\" }) }}",
  "timestamp/LiveLocation": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/MessageTimestamp": "{{ timestamp | timestampFormatter(calendar: false; format: HH:mm) }}",
  "timestamp/PollVote": "{{ timestamp | timestampFormatter(relativeCompact: true) }}",
  "timestamp/PollVoteTooltip": "{{ timestamp | timestampFormatter(calendar: true) }}",
  "timestamp/relativeDaysAgo": "{{ count }}日前",
  "timestamp/relativeToday": "今日",
  "timestamp/relativeWeeksAgo": "{{ count }}週間前",
  "timestamp/relativeYesterday": "昨日",
  "timestamp/ReminderNotification": "{{ timestamp | timestampFormatter(calendar: true; calendarFormats: { \"sameDay\": \"[今日] HH:mm\", \"nextDay\": \"[明日] HH:mm\", \"lastDay\": \"[昨日] HH:mm\", \"nextWeek\": \"dddd HH:mm\", \"lastWeek\": \"dddd HH:mm\", \"sameElse\": \"ddd, D MMM HH:mm\" }) }}",
  "timestamp/SystemMessage": "{{ timestamp | timestampFormatter(format: dddd L) }}",
  "To start recording, allow the camera access in your browser": "録音を開始するには、ブラウザーでカメラへのアクセスを許可してください",
  "To start recording, allow the microphone access in your browser": "録音を開始するには、ブラウザーでマイクロフォンへのアクセスを許可してください",
  "totalVoteCount_other": "合計{{ count }}票",
  "Translated": "翻訳済み",
  "Translated from {{ language }}": "{{ language }}から翻訳",
  "translationBuilderTopic/notification": "{{value, notification}}",
  "Type a number from 2 to 10": "2から10までの数字を入力してください",
  "Unarchive": "アーカイブ解除",
  "unban-command-args": "[@ユーザ名]",
  "unban-command-description": "ユーザーの禁止を解除する",
  "Unblock": "ブロック解除",
  "Unblock user": "ユーザーのブロックを解除",
  "Unblock User": "ユーザーのブロックを解除",
  "unknown error": "不明なエラー",
  "Unmute": "無音を解除する",
  "Unmute chat": "チャットのミュートを解除",
  "Unmute user": "ユーザーのミュートを解除",
  "unmute-command-args": "[@ユーザ名]",
  "unmute-command-description": "ユーザーのミュートを解除する",
  "Unpin": "ピンを解除する",
  "Unread messages": "未読メッセージ",
  "Unsupported attachment": "サポートされていない添付ファイル",
  "unsupported file type": "サポートされていないファイル形式",
  "Update": "更新",
  "Update the comment attached to your poll answer": "投票回答に添付されたコメントを更新",
  "Update your comment": "コメントを更新",
  "Upload blocked": "アップロードがブロックされました",
  "Upload error": "アップロードエラー",
  "Upload failed": "アップロードに失敗しました",
  "Upload Picture": "画像をアップロード",
  "Upload type: \"{{ type }}\" is not allowed": "アップロードタイプ：\"{{ type }}\"は許可されていません",
  "User blocked": "ユーザーをブロックしました",
  "User muted": "ユーザーをミュートしました",
  "User removed": "ユーザーを削除しました",
  "User unblocked": "ユーザーのブロックを解除しました",
  "User unmuted": "ユーザーのミュートを解除しました",
  "User uploaded content": "ユーザーがアップロードしたコンテンツ",
  "Video": "動画",
  "videoCount_other": "{{ count }}件の動画",
  "View": "表示",
  "View {{count}} comments_one": "{{count}} コメントを表示",
  "View {{count}} comments_other": "{{count}} コメントを表示",
  "View all": "すべて表示",
  "View member details for {{ member }}": "{{ member }}のメンバー詳細を表示",
  "View original": "原文を表示",
  "View results": "結果を表示",
  "View translation": "翻訳を表示",
  "Voice message": "ボイスメッセージ",
  "Voice message {{ duration }}": "ボイスメッセージ {{ duration }}",
  "Voice message deleted": "ボイスメッセージが削除されました",
  "voiceMessageCount_other": "{{ count }}件のボイスメッセージ",
  "Vote ended": "投票が終了しました",
  "Votes": "投票",
  "Wait until all attachments have uploaded": "すべての添付ファイルがアップロードされるまでお待ちください",
  "Waiting for network…": "ネットワークを待機中…",
  "You": "あなた",
  "You've reached the maximum number of files": "ファイルの最大数に達しました"
}
